import type { SidePanel } from '../types';

export const TransferMoney: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./TransferMoneyPanel.vue')),
};
